/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...




/*-----------------------------------------------------------------------------/
                          page specialty services popup
/-----------------------------------------------------------------------------*/

$(function() {
	//----- OPEN
	$('[specialty-servicedata-popup-open]').on('click', function(e) {
		var targeted_popup_class = jQuery(this).attr('specialty-servicedata-popup-open');
		$('[specialty-servicedata-popup="' + targeted_popup_class + '"]').fadeIn(350);
         $(".specialtyServices").addClass("openspecialtyServices");
		e.preventDefault();
	});

	//----- CLOSE
	$('[specialty-servicedata-popup-close]').on('click', function(e) {
		var targeted_popup_class = jQuery(this).attr('specialty-servicedata-popup-close');
		$('[specialty-servicedata-popup="' + targeted_popup_class + '"]').fadeOut(350);
         $(".specialtyServices").removeClass("openspecialtyServices");
		e.preventDefault();
	});
});